/* eslint-disable react/react-in-jsx-scope */
import ManagePictureProfil from "@/auth/components/ManagePictureProfil";
import { useAuth } from "@/auth/hooks/useAuth";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import {
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { LoadingSpinner } from "@/components/ui/loadingSpinner";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { useToast } from "@/components/ui/use-toast";
import { langs } from "@/constants/constants";
import { useIsMobile } from "@/hooks/use-mobile";
import { useFunding } from "@/hooks/useFunding";
import usePostData from "@/hooks/usePostData";
import i18n from "@/i18n";
import { useLogoStore } from "@/store/store";
import { DropdownMenu } from "@radix-ui/react-dropdown-menu";
import {
  ChevronDown,
  LogOut,
  Menu,
  User2,
  UserPen,
  Wallet,
} from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSidebar } from "../ui/sidebar";
const HeaderTop = () => {
  const { t } = useTranslation("dashboard", {
    keyPrefix: "common",
  });
  const { user, logout, setAuthState, loading } = useAuth();
  const [idMedia, setIdMedia] = useState(null);
  const [photoUrl, setPhotoUrl] = useState("");
  const [openEditProfil, setOpenEditProfil] = useState(false);
  const [openProfilePopover, setOpenProfilePopover] = useState(false);
  const Funding = useFunding();
  const [firstname, setFirstname] = useState(user?.firstname);
  const [lastname, setLastname] = useState(user?.lastname);
  const [structureName, setStructureName] = useState(user?.structureName);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const isMobile = useIsMobile();
  const [loadingEditProfil, setLoadingEditProfil] = useState(false);

  const { postData } = usePostData();

  const { toast } = useToast();
  const { open, toggleSidebar } = useSidebar();

  useEffect(() => {
    setFirstname(user?.firstname);
    setLastname(user?.lastname);
    setStructureName(user?.structureName);
    setPhotoUrl(user?.photo?.uri);
  }, [user]);

  const { logoUrl } = useLogoStore();
  const handleEditProfil = async () => {
    setLoadingEditProfil(true);
    // Construire dynamiquement les données à envoyer
    const dataToSend: Record<string, any> = {
      firstname,
      lastname,
      structureName,
      email: user?.email,
      photo: idMedia,
    };

    // Ajouter les champs de mot de passe seulement s'ils sont remplis
    if (password !== "") {
      dataToSend.password = password;
      dataToSend.confirmPassword = confirmPassword;
    }

    const res = await postData({
      url: `${import.meta.env.VITE_IP_API}/api/profil`,
      data: dataToSend,
    });
    if (res === null) {
      setLoadingEditProfil(false);
      return;
    }

    setAuthState({ user: res, loading: false, error: null });

    setLoadingEditProfil(false);

    toast({
      title: t("Votre profil a bien été modifié."),
      duration: 1000,
    });

    setOpenEditProfil(false);
  };

  return (
    <div className="flex flex-wrap items-center justify-end pt-7 ">
      {isMobile && (
        <div className="flex mr-auto items-center">
          <Button
            variant="ghost"
            size="icon"
            className="h-7 w-7 mr-4"
            onClick={(event) => {
              event.preventDefault();
              toggleSidebar();
            }}
          >
            <Menu size={18} className="text-muted" />
            <span className="sr-only">Toggle Sidebar</span>
          </Button>
          <div className={`max-w-24 overflow-hidden `}>
            {!loading &&
              (logoUrl ? (
                <img
                  src={import.meta.env.VITE_MEDIA_BASE + logoUrl}
                  alt="logo verdeo"
                  className=" w-full h-auto"
                />
              ) : (
                <img
                  src="/logo.svg"
                  alt="logo verdeo"
                  className=" w-24 h-auto"
                />
              ))}
          </div>
        </div>
      )}
      {import.meta.env.VITE_ENV !== undefined &&
        import.meta.env.VITE_ENV !== "prod" && (
          <p className="text-[#f00] text-[16px] font-bold absolute left-1/2 -translate-x-1/2">
            Environnement: {import.meta.env.VITE_ENV}
          </p>
        )}
      <div className="flex flex-row w-full items-center gap-2 md:gap-5 justify-between">
        <div className="flex flex-row items-center gap-2 md:gap-5">
          <p className="m-0">Financements confiés</p>
          <Wallet />
          <p className="m-0 font-bold text-xl">
            {parseFloat(Funding?.toFixed(2)).toLocaleString("fr-FR")} €{" "}
          </p>
          <Button className="rounded-[20px]" disabled>
            {" "}
            Nouveau Financement
          </Button>
        </div>
        <div className="flex flex-row gap-4">
          <DropdownMenu>
            <DropdownMenuTrigger asChild className="cursor-pointer">
              <div className="flex items-center">
                {i18n === undefined ||
                i18n === null ||
                i18n.language === undefined ||
                i18n.language === null
                  ? "FR"
                  : i18n.language.split("-")[0].toUpperCase()}
                <ChevronDown className="size-4 opacity-50" />
              </div>
            </DropdownMenuTrigger>
            <DropdownMenuContent className="min-w-[10px]">
              <DropdownMenuGroup className="w-[50px]">
                {langs.map((lang, key) => (
                  <DropdownMenuItem
                    className="cursor-pointer hover:bg-white focus:bg-white focus:text-black"
                    onClick={() => {
                      i18n.language !== lang && i18n.changeLanguage(lang);
                    }}
                    key={key}
                  >
                    {lang.toUpperCase()}
                  </DropdownMenuItem>
                ))}
              </DropdownMenuGroup>
            </DropdownMenuContent>
          </DropdownMenu>
          <Popover open={openProfilePopover} onOpenChange={setOpenProfilePopover}>
            <PopoverTrigger asChild>
              <div className="flex cursor-pointer items-center gap-1 text-muted hover:bg-foreground p-2 rounded-lg group transition-all">
                {user ? (
                  <div className="flex gap-2 items-center">
                    {photoUrl ? (
                      <div className="relative flex justify-center items-center    transition-all shrink-0 overflow-hidden size-10 rounded-lg">
                        <div className="w-full rounded-full aspect-square overflow-hidden">
                          <img
                            src={import.meta.env.VITE_MEDIA_BASE + photoUrl}
                            alt="photo de profil"
                            className="size-full object-cover"
                          />
                        </div>
                      </div>
                    ) : (
                      <div className="relative flex justify-center items-center bg-gray-100 group-hover:bg-background transition-all shrink-0 overflow-hidden size-10 rounded-lg">
                        <User2 className="group-hover:text-foreground" />
                      </div>
                    )}
                    {!isMobile && (
                      <div className="flex flex-col justify-center">
                        <p className="text-foreground m-0 group-hover:text-background">
                          {user?.fullname}
                        </p>
                        <p className="text-[10px] m-0 group-hover:text-background text-foreground opacity-45">
                          {user?.email}
                        </p>
                      </div>
                    )}
                  </div>
                ) : (
                  <LoadingSpinner />
                )}
              </div>
            </PopoverTrigger>
            <PopoverContent className="w-max">
              <div className="mb-2 flex items-center gap-1">
                <User2 />
                <div>
                  <p className="m-0 text-xs font-light">
                    {t("Connecté en tant que")}
                  </p>
                  <p className="m-0">{user?.fullname}</p>
                </div>
              </div>
              <hr />
              <div
                className="flex cursor-pointer items-center gap-2 py-2 transition-all hover:text-[#555]"
                onClick={() => {
                  setOpenProfilePopover(false);
                  setOpenEditProfil(true);
                }}
              >
                <UserPen size={20} />
                {t("Profil")}
              </div>
              <hr />
              <AlertDialog>
                <AlertDialogTrigger asChild>
                  <div className="flex cursor-pointer items-center gap-2 py-2  transition-all hover:text-destructive">
                    <LogOut size={20} />
                    {t("Déconnexion")}
                  </div>
                </AlertDialogTrigger>
                <AlertDialogContent>
                  <AlertDialogHeader>
                    <AlertDialogTitle>
                      {t("Êtes-vous sûr de vouloir vous déconnecter ?")}
                    </AlertDialogTitle>
                  </AlertDialogHeader>
                  <AlertDialogFooter>
                    <AlertDialogCancel>{t("Annuler")}</AlertDialogCancel>
                    <AlertDialogAction
                      onClick={() => logout(window.location.href)}
                    >
                      {t("Se déconnecter")}
                    </AlertDialogAction>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialog>
            </PopoverContent>
          </Popover>
          <AlertDialog
            open={openEditProfil}
            onOpenChange={setOpenEditProfil}
          >
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>
                  {t("Modifier mon profil")}
                </AlertDialogTitle>
              </AlertDialogHeader>
              <div className="mt-3">
                <div className="space-y-2">
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {t("Photo de profil")}
                  </label>
                  <div className="size-24">
                    <ManagePictureProfil
                      setIdMedia={setIdMedia}
                      loadingEditProfil={loadingEditProfil}
                      photoUrl={photoUrl}
                      setPhotoUrl={setPhotoUrl}
                    />
                  </div>
                </div>
                <div className="mt-4 space-y-2">
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {t("Nom")}
                  </label>
                  <input
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    type="text"
                    name="name"
                    value={lastname}
                    onChange={(e) => setLastname(e.target.value)}
                  />
                </div>
                <div className="mt-4 space-y-2">
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {t("Prénom")}
                  </label>
                  <input
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    type="text"
                    name="firstname"
                    value={firstname}
                    onChange={(e) => setFirstname(e.target.value)}
                  />
                </div>
                <div className="mt-4 space-y-2">
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {t("Nom de la structure")}
                  </label>
                  <input
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    type="text"
                    name="structureName"
                    value={structureName}
                    onChange={(e) => setStructureName(e.target.value)}
                  />
                </div>

                <div className="mt-4 space-y-2">
                  <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                    {t("Mot de passe")} -{" "}
                    <span className="font-light opacity-50">
                      ({t("Laissez vide pour ne pas changer.")})
                    </span>
                  </label>
                  <input
                    className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    type="password"
                    name="password"
                    autoComplete="new-password"
                    autoCorrect="off"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                {password != "" && (
                  <div className="mt-4 space-y-2">
                    <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                      {t("Confirmation mot de passe")}
                    </label>
                    <input
                      className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                      type="password"
                      name="confirmPassword"
                      autoComplete="new-password"
                      autoCorrect="off"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                  </div>
                )}
                {password !== "" &&
                  confirmPassword !== "" &&
                  confirmPassword !== password && (
                    <div className="mt-2 text-sm text-red-500">
                      {t("Les mots de passe ne correspondent pas.")}
                    </div>
                  )}
              </div>
              <AlertDialogFooter>
                <AlertDialogCancel>{t("Annuler")}</AlertDialogCancel>

                <AlertDialogAction
                  disabled={
                    loadingEditProfil ||
                    (password !== "" && confirmPassword !== password)
                  }
                  onClick={(e) => {
                    e.preventDefault();
                    if (
                      password === "" ||
                      (password !== "" && confirmPassword === password)
                    ) {
                      handleEditProfil();
                    }
                  }}
                >
                  {t("Sauvegarder")}
                </AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </div>
      <hr className="w-full bg-gray-200 rounded-xl " />
    </div>
  );
};

export default HeaderTop;
